module.exports = __webpack_public_path__ + "img/banner1.87b5b723.png";